import type {
  InitialFormValues,
  QueryParameters,
} from '../../../../components/CarFinancePage/queries/schema/carFinance.schema';
import { BankOfIrelandFinanceForm } from '../../../../components/CarFinancePage/financeProviders/bankofireland/BankOfIrelandForm';
import { CloseBrothersFinanceForm } from '../../../../components/CarFinancePage/financeProviders/closebrothers/CloseBrothersForm';

type SwitchOnProviderProps = {
  query: QueryParameters;
  onSubmitCallback: () => void;
  onSubmitErrorCallback: (errorFields: Array<string>) => void;
  initialFormData: InitialFormValues;
};

/**
 * Each provider has their own form as there are variations in fields and requirements between them.
 * Any new provider should be added here as a new case.
 */
const SwitchOnProvider = (props: SwitchOnProviderProps) => {
  const {
    query: { provider },
  } = props;
  switch (provider) {
    case 'bankofireland':
      return <BankOfIrelandFinanceForm {...props} />;
    case 'closebrothers':
      return <CloseBrothersFinanceForm {...props} />;
    default:
      // TODO: Unknown provider, show error page (should never happen as provider is validated)
      return null;
  }
};

export { SwitchOnProvider };
